import { codeData, qrcodeData, wxBind, accountLogin, codeLogin, register, userinfoData, adminUserLogin } from "../../../api/main/login.js";
let modules = {
  namespaced: true,
  state: {
    userinfo: localStorage['userinfo'] ? JSON.parse(localStorage['userinfo']) : "",
    uid: localStorage["uid"] ? localStorage["uid"] : "",
    avatar: localStorage["avatar"] ? localStorage["avatar"] : "",
  },
  mutations: {
    ["SET_USER"] (state, payload) {
      state.userinfo = payload.userinfo
      state.uid = payload.userinfo.id
      state.avatar = payload.userinfo.avatar
      localStorage["userinfo"] = JSON.stringify(payload.userinfo)
      localStorage["uid"] = payload.userinfo.id
      localStorage["avatar"] = payload.userinfo.avatar
    },
    ["OUT_LOGIN"] (state) {
      state.userinfo = ""
      state.uid = ""
      state.avatar = ""
      localStorage.removeItem("userinfo")
      localStorage.removeItem("uid")
      localStorage.removeItem("avatar")
    },
    ["SET_USERAVATAR"] (state, payload) {
      localStorage["avatar"] = payload.avatar
    },
  },
  actions: {
    getCodeData (conText, payload) {//获取手机短信验证码
      codeData(payload.data).then(res => {
        if (payload.success) {
          payload.success(res)
        }
      })
    },
    getQrcodeData (conText, payload) {//获取二维码
      qrcodeData(payload.data).then(res => {
        if (payload.success) {
          payload.success(res)
        }
      })
    },
    checkWxBind (conText, payload) {//检测微信绑定
      wxBind(payload.data).then(res => {
        if (res.code == 200) {
          conText.commit("SET_USER", { userinfo: res.data.userinfo })
        }
        if (payload.success) {
          payload.success(res)
        }
      })
    },
    DoAccountLogin (conText, payload) {//账号密码登录
      console.log(conText)
      accountLogin(payload.data).then(res => {
        console.log('vuex success account login', res)
        if (res.code == 200) {
          conText.commit("SET_USER", { userinfo: res.data.userinfo })
        }
        if (payload.success) {
          payload.success(res)
        }
      })
    },
    DoCodeLogin (conText, payload) {//短信验证码登录
      codeLogin(payload.data).then(res => {
        console.log('vuex success code login', res)
        if (res.code == 200) {
          conText.commit("SET_USER", { userinfo: res.data.userinfo })
        }
        if (payload.success) {
          payload.success(res)
        }
      })
    },
    DoRegister (conText, payload) {//账户注册
      register(payload.data).then(res => {
        console.log('vuex success register', res)
        if (payload.success) {
          payload.success(res)
        }
      })
    },
    getUserinfoData (conText, payload) {//获取个人信息
      userinfoData(payload.data).then(res => {
        if (res.code == 200) {
          console.log('cccccccc', res)
          conText.commit("SET_USERAVATAR", { avatar: res.data.avatar })
        }
        if (payload.success) {
          payload.success(res)
        }
      })
    },
    //登录
    doAdminUserLogin (conText, payload) {
      adminUserLogin(payload.data, payload.headers).then(res => {
        if (res.code == 1) {
          // 存储 token 到 localStorage（持久化）
          const token = res.data.token;
          localStorage.setItem('auth_token', token);
        }
        if (payload.success) {
          payload.success(res)
        }
      })
    }
  }

}
export default modules;
